<div class="card card-default">
    <div class="card-body">
      <div class="card-header" style="padding-left: 0px !important">Upload File{{(this.allowMultiple?'s':'')}}</div>
        <div ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (onFileDrop)="dropped($event)" (fileOver)="fileOverBase($event)" [uploader]="uploader" class="box-placeholder my-drop-zone">
          Drag and drop file{{(this.allowMultiple?'s':'')}} here <span style="padding-left:1em">{{specificationText}}</span>
        </div>
        <label for="file1" class="file-upload" *ngIf="allowMultiple">
            <button class="btn btn-secondary btn-block">Click here to upload multiple files</button>
            <input id="file1" type="file" ng2FileSelect [uploader]="uploader" multiple [hidden]="!allowMultiple" />
            <input id="file1" type="file" ng2FileSelect [uploader]="uploader" [hidden]="allowMultiple" />
        </label>
        <div *ngIf="uploader.queue.length > 0 ">
            <div class="card-header" style="padding-left: 0px !important" *ngIf="allowMultiple">Upload queue</div>
            <table class="table">
                <thead>
                    <tr>
                        <th width="50%">Name</th>
                        <th class="text-center">Status</th>
                        <th *ngIf="showIndivdualUpload">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of uploader.queue">
                        <td>
                            <strong>{{ item?.file?.name }}</strong>
                        </td>
                        <td class="text-center">
                            <span *ngIf="item.isSuccess">
                                <em class="fa fa-check"></em>
                            </span>
                            <span *ngIf="item.isCancel">
                                <em class="fa fa-close"></em>
                            </span>
                            <span *ngIf="item.isError">
                                <em class="fa fa-warning"></em>
                            </span>
                        </td>
                        <td nowrap *ngIf="showIndivdualUpload">
                            <button type="button" class="btn btn-info btn-xs" (click)="item.upload()" [disabled]="item.isReady || item.isUploading || item.isSuccess">
                                <span class="fa icon-cloud-upload mr"></span> Upload
                            </button>
                            <button type="button" class="btn btn-warning btn-xs" (click)="item.cancel()" [disabled]="!item.isUploading">
                                <span class="icon-close mr"></span> Cancel
                            </button>
                            <button type="button" class="btn btn-danger btn-xs" [disabled]="item.isSuccess" (click)="item.remove()">
                                <span class="icon-trash mr"></span> Remove
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-header" style="padding-left: 0px !important" *ngIf="uploader.queue.length > 0 && !hideProgressBar">Queue Progress</div>
        <div class="form-group" *ngIf="uploader.queue.length > 0 && !hideProgressBar">
            <div class="form-group row">
                <div class="progress col-md-11" style="margin-left: 15px; padding: 0px !important">
                    <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': uploader.progress + '%' }"></div>
                </div>
                <div class="col-md-1"></div>
            </div>

            <div class="form-group d-flex flex-row col-sm-4" *ngIf="allowMultiple">
                <div p-2>
                    <button type="button" class="btn btn-info btn-s" (click)="uploader.uploadAll()" [disabled]="!uploader.getNotUploadedItems().length">
                        <span class="fa icon-cloud-upload mr"></span> Upload
                        <div *ngIf="allowMultiple" style="display: inline"> all</div>
                    </button>
                </div>
                <div p-2>
                    <button type="button" class="btn btn-warning btn-s" (click)="uploader.cancelAll()" [disabled]="!uploader.isUploading">
                        <span class="icon-close mr"></span> Cancel
                        <div *ngIf="allowMultiple" style="display: inline"> all</div>
                    </button>
                </div>
                <div p-2>
                    <button type="button" class="btn btn-danger btn-s" (click)="clearFiles()" [disabled]="!uploader.queue.length">
                        <span class="icon-trash mr"></span> Remove
                        <div *ngIf="allowMultiple" style="display: inline"> all</div>
                    </button>

                </div>
            </div>
        </div>
    </div>
</div>
